import React, { useState } from "react";
import NavBar from "./NavBar";
import BackgroundImage from "./../images/contactus_background.jpg";
import { useNavigate } from "react-router-dom";
import { axiosReqConfig } from "../functions/axiosRequest";
import { API_IP } from "../global_variables";

const PlatformOrientation = () => {
  const navigate = useNavigate();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);

  const [formData, setFormData] = useState({
    helpNeeded: [],
    format: "",
    city: "",
    notes: "",
    fullName: "",
    contactMethod: "",
    contactValue: "",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleCheckboxChange = (e) => {
    const { value, checked } = e.target;
    let updatedHelp = [...formData.helpNeeded];
    if (checked) {
      updatedHelp.push(value);
    } else {
      updatedHelp = updatedHelp.filter((item) => item !== value);
    }
    setFormData({ ...formData, helpNeeded: updatedHelp });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    const result = await axiosReqConfig(
      `${API_IP}/api/platform-orientation`,
      "post",
      formData,
    );

    setIsSubmitting(false);

    if (result && result !== undefined) {
      setIsSuccess(true);
    } else {
      alert("Failed to submit request. Please try again.");
    }
  };

  return (
    <div>
      <div
        className="homeHeaderContainer"
        style={{
          backgroundImage: `url(${BackgroundImage})`,
          width: "100vw",
          height: "70vh",
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      >
        <div>
          <h1 className="homeTitleText">Platform Orientation</h1>
        </div>
      </div>

      <div className="homeBodyContainer">
        <div className="ContactUsTitleContainer">
          <h1>Free iCare Village Platform Orientation</h1>
          <p>
            A free session to help you understand and use the iCare Village
            platform to access care services. This is not general technology
            support.
          </p>
        </div>

        <div className="ContactUsBodyContainer">
          <div className="POFormContainer">
            {isSuccess ? (
              <div className="POSuccessContainer">
                <img
                  src={require("../images/booking_accepted_icon.webp")}
                  alt="Success"
                  className="POSuccessIcon"
                />
                <h2 className="POSuccessTitle">Request Sent Successfully!</h2>
                <p className="POSuccessMessage">
                  Thank you, <strong>{formData.fullName}</strong>. We have
                  received your request for a platform orientation. One of our
                  team members will contact you via{" "}
                  <strong>{formData.contactMethod}</strong> shortly to confirm
                  the details.
                </p>
                <button
                  className="POSubmitButton"
                  onClick={() => navigate("/")}
                  style={{ width: "auto", padding: "12px 40px" }}
                >
                  Return to Home
                </button>
              </div>
            ) : (
              <form onSubmit={handleSubmit}>
                <div className="POFormGroup POCheckboxGroup">
                  <label className="POCheckboxTitle">
                    1. What would you like help with? (Select all that apply)
                  </label>
                  {[
                    "Booking a care service",
                    "Understanding services and pricing",
                    "Creating or using an iCare Village account",
                    "Joining an online consultation or appointment",
                    "Not sure — I’d like someone to guide me",
                  ].map((item, index) => (
                    <div
                      key={index}
                      className="POCheckboxItem"
                      onClick={() => {
                        const isChecked = formData.helpNeeded.includes(item);
                        handleCheckboxChange({
                          target: { value: item, checked: !isChecked },
                        });
                      }}
                    >
                      <input
                        type="checkbox"
                        value={item}
                        checked={formData.helpNeeded.includes(item)}
                        onChange={() => {}}
                        className="POCheckboxInput"
                        style={{ pointerEvents: "none" }}
                      />
                      <label className="POCheckboxLabel">{item}</label>
                    </div>
                  ))}
                </div>

                <div className="POFormGroup POCheckboxGroup">
                  <label className="POCheckboxTitle">
                    2. Preferred orientation format (Choose one)
                  </label>
                  <p
                    style={{
                      fontSize: "14px",
                      color: "#666",
                      marginTop: "-10px",
                      marginBottom: "10px",
                    }}
                  >
                    * Online sessions are used only for iCare Village
                    consultations.
                  </p>
                  {[
                    "In-home visit",
                    "Phone call",
                    "Online (video) session",
                  ].map((item, index) => (
                    <div
                      key={index}
                      className="POCheckboxItem"
                      onClick={() =>
                        handleChange({
                          target: { name: "format", value: item },
                        })
                      }
                    >
                      <input
                        type="radio"
                        name="format"
                        value={item}
                        checked={formData.format === item}
                        onChange={() => {}}
                        className="POCheckboxInput"
                        required
                        style={{ borderRadius: "50%", pointerEvents: "none" }}
                      />
                      <label className="POCheckboxLabel">{item}</label>
                    </div>
                  ))}
                </div>

                <div className="POFormGroup">
                  <label>3. City or area</label>
                  <input
                    type="text"
                    name="city"
                    placeholder="Example: Victoria, BC"
                    value={formData.city}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="POFormGroup">
                  <label>4. Anything you’d like us to know? (Optional)</label>
                  <textarea
                    name="notes"
                    rows="3"
                    placeholder="“I’m not very comfortable using websites” or “I tried booking but got stuck”"
                    value={formData.notes}
                    onChange={handleChange}
                  />
                </div>

                <div className="POFormGroup">
                  <label>5. Your name</label>
                  <input
                    type="text"
                    name="fullName"
                    placeholder="Full name"
                    value={formData.fullName}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="POFormGroup POCheckboxGroup">
                  <label className="POCheckboxTitle">
                    6. How would you like us to contact you?
                  </label>
                  <div
                    style={{
                      display: "flex",
                      gap: "20px",
                      marginBottom: "15px",
                    }}
                  >
                    <div
                      className="POCheckboxItem"
                      onClick={() =>
                        handleChange({
                          target: { name: "contactMethod", value: "Phone" },
                        })
                      }
                    >
                      <input
                        type="radio"
                        name="contactMethod"
                        value="Phone"
                        checked={formData.contactMethod === "Phone"}
                        onChange={() => {}}
                        className="POCheckboxInput"
                        required
                        style={{ borderRadius: "50%", pointerEvents: "none" }}
                      />
                      <label className="POCheckboxLabel">Phone</label>
                    </div>
                    <div
                      className="POCheckboxItem"
                      onClick={() =>
                        handleChange({
                          target: { name: "contactMethod", value: "Email" },
                        })
                      }
                    >
                      <input
                        type="radio"
                        name="contactMethod"
                        value="Email"
                        checked={formData.contactMethod === "Email"}
                        onChange={() => {}}
                        className="POCheckboxInput"
                        required
                        style={{ borderRadius: "50%", pointerEvents: "none" }}
                      />
                      <label className="POCheckboxLabel">Email</label>
                    </div>
                  </div>

                  {formData.contactMethod && (
                    <input
                      type={
                        formData.contactMethod === "Email" ? "email" : "tel"
                      }
                      name="contactValue"
                      placeholder={
                        formData.contactMethod === "Email"
                          ? "Enter your email address"
                          : "Enter your phone number"
                      }
                      value={formData.contactValue}
                      onChange={handleChange}
                      required
                    />
                  )}
                </div>

                <button
                  type="submit"
                  className="POSubmitButton"
                  disabled={isSubmitting}
                  style={{ opacity: isSubmitting ? 0.7 : 1 }}
                >
                  {isSubmitting
                    ? "Sending Request..."
                    : "Request Free Orientation"}
                </button>
              </form>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PlatformOrientation;
